const StatType = {
    Avg:          { key: 'avg', name: 'Average'},
    Min:          { key: 'min', name: 'Minimum'},
    Max:          { key: 'max', name: 'Maximum'},
    StDev:        { key: 'dev', name: 'Standard deviation'},
    Count:        { key: 'count', name: 'Count'},
    Sum:          { key: 'sum', name: 'Sum' },
    Range:        { key: 'range', name: 'Range' },
    Ratio:        { key: 'ratio', name: 'Ratio'},
    CV:           { key: 'cv', name: 'Coefficient of variation'}, // https://en.wikipedia.org/wiki/Coefficient_of_variation#Estimation
    Q1:           { key: 'q1', name: 'First quartile' },
    Q2:           { key: 'q2', name: 'Second quartile, Median' }, // https://en.wikipedia.org/wiki/Quartile
    Q3:           { key: 'q3', name: 'Third quartile' },
    QCD:          { key: 'qcd', name: 'Quartile coefficient of dispersion' }, // https://en.wikipedia.org/wiki/Quartile_coefficient_of_dispersion
    IQR:          { key: 'iqr', name: 'Interquartile range' }, // https://en.wikipedia.org/wiki/Interquartile_range
};

export default StatType;